<ul>
    <li *ngFor="let item of selectedTreeList; index as i;" [class.new-branch]="level===1">
        <mat-icon *ngIf="item.selected" aria-hidden="false" aria-label="Selected">check_box</mat-icon>{{item.Description}}
        <!-- {{item | json}} -->
        <se-selected-items-visualizer *ngIf="item.children" [selectedTreeList]="item.children" [level]="level+1">
        </se-selected-items-visualizer>
    </li>
</ul>
